import { CalendarType, TenantType } from '@xeetr/types/enums'
import { Settings } from '@xeetr/types/models'
import { Controller, useFormContext } from 'react-hook-form'

import FloatingLabel from '../../inputs/FloatingLabel'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useTenant } from '@/hooks/useTenant'

const TenantCalendar = () => {
  const { tenant } = useTenant()

  const { control } = useFormContext<Settings>()

  const calendarTypeItems = [
    { label: 'Tag', value: CalendarType.DAY },
    ...(tenant?.type === TenantType.SERVICE ? [{ label: 'Woche', value: CalendarType.WEEK }] : []),
    { label: 'Monat', value: CalendarType.MONTH },
  ]

  const displayPreferenceItems = [
    { label: 'Mitarbeiter', value: 'employee' },
    { label: 'Kunde', value: 'customer' },
  ]

  return (
    <div className="space-y-10">
      {/* Calendar View Settings Section */}
      <section>
        <div className="mb-6">
          <h2 className="text-lg font-semibold">Kalenderansicht</h2>
          <p className="text-muted-foreground text-sm">
            Konfigurieren Sie die Standardansicht und Anzeigeoptionen des Kalenders.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          <Controller
            name="tenant.settings.calendarType"
            control={control}
            render={({ field }) => (
              <FloatingLabel label="Standardansicht des Kalenders">
                <Select defaultValue={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className="w-full">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {calendarTypeItems.map((item) => (
                      <SelectItem key={item.value} value={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </FloatingLabel>
            )}
          />
          {tenant?.type === TenantType.SERVICE && (
            <>
              <Controller
                name="tenant.settings.calendarDisplayPreference"
                control={control}
                render={({ field }) => (
                  <FloatingLabel label="Kalender Anzeige">
                    <Select defaultValue={field.value} onValueChange={field.onChange}>
                      <SelectTrigger className="w-full">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent {...field}>
                        {displayPreferenceItems.map((item) => (
                          <SelectItem key={item.value} value={item.value}>
                            {item.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </FloatingLabel>
                )}
              />
              <Controller
                name="tenant.settings.showAddressInCalendar"
                control={control}
                render={({ field }) => (
                  <FloatingLabel label="Adresse im Kalender anzeigen">
                    <Select
                      value={field.value ? 'true' : 'false'}
                      onValueChange={(value) => field.onChange(value === 'true')}
                    >
                      <SelectTrigger className="w-full">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="true">Ja</SelectItem>
                        <SelectItem value="false">Nein</SelectItem>
                      </SelectContent>
                    </Select>
                  </FloatingLabel>
                )}
              />
            </>
          )}
        </div>
      </section>
    </div>
  )
}

export default TenantCalendar
